import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbDataValueRenderer } from "abreact/data/AbDataValueRenderer";
import * as AbFormHooks from "abreact/form/AbFormHooks";
import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { AbCheckbox } from "abreact/input/AbCheckbox";
import { AbDropdown } from "abreact/input/AbDropdown";
import * as AbWebResources from "abweb/generated/locale/AbWebResources";
import * as React from "react";
export function AbBooleanDataValueInput(props) {
  const viewModel = AbFormHooks.useDataValueInputViewModel("ab-boolean-data-value-input", props);
  if (!viewModel) {
    return null;
  }
  const currentValue = viewModel.currentValue;
  if (!viewModel.isEditing) {
    return currentValue != null && props.valueRenderer ? /*#__PURE__*/React.createElement("div", viewModel.readOnlyProps, props.valueRenderer(currentValue)) : /*#__PURE__*/React.createElement(AbDataValueRenderer, _extends({}, viewModel.readOnlyProps, {
      dataTestId: props.dataTestId,
      subject: props.subject,
      accessor: props.accessor,
      currentValue: props.currentValue
    }));
  } else if (props.accessor.constraints?.cannotBeNull) {
    return /*#__PURE__*/React.createElement(AbCheckbox, _extends({}, viewModel.inputProps, {
      value: currentValue ?? false,
      onChange: viewModel.changeValue
    }));
  } else {
    const itemRenderer = props.valueRenderer || (item => booleanItemRenderer(props, item));
    return /*#__PURE__*/React.createElement(AbDropdown, _extends({}, viewModel.inputProps, {
      items: [null, true, false],
      itemRenderer: itemRenderer,
      value: currentValue,
      onChange: viewModel.changeValue
    }));
  }
}
function booleanItemRenderer(props, value) {
  if (value === true) {
    return props.trueLabel ?? AbWebResources.yes();
  } else if (value === false) {
    return props.falseLabel ?? AbWebResources.no();
  } else {
    return AbReactResources.booleanChoices_unspecified();
  }
}
//# sourceMappingURL=AbBooleanDataValueInput.js.map
